import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchUserPaidReturn } from '../../../cores/api/api-dashboard';
import BarChart from '../../components/bar-chart';
import { formatTotalUser } from '../../../utils/utils';
export default function SectionUserPaidReturnChart() {
    var _a;
    const _useQuery = useQuery({
        queryKey: ['fetchUserPaidReturn'],
        queryFn: () => fetchUserPaidReturn(),
        suspense: true
    }), data = _useQuery.data;
    const retentionData = (_a = data === null || data === void 0 ? void 0 : data.retention_data) !== null && _a !== void 0 ? _a : {};
    const ORDER = ['1年以上', '6ヶ月', '3ヶ月', '2ヶ月', '1ヶ月'];
    const labels = ORDER.filter(k => retentionData[k]);
    const percents = labels.map(k => retentionData[k].percent);
    const barData = {
        labels,
        datasets: [{
                label: '継続利用率',
                data: percents,
                backgroundColor: '#2563eb',
                borderRadius: 6,
                barThickness: 26
            }]
    };
    return /*#__PURE__*/ React.createElement(BarChart, {
        title: "\u7D99\u7D9A\u5229\u7528\u7387",
        userCountText: `${formatTotalUser({
            value: (data === null || data === void 0 ? void 0 : data.total_users) || 0
        })} ユーザー`,
        data: barData
    });
}
